import { useEffect } from 'react';
import { useLocalObservable } from 'mobx-react-lite';

import wrapInObserver from '../wrapInObserver';
import App from './App';
import logger from '../../logger';
import generatedHooks from '../../hooks/generatedHooks';
import i18n from '../../i18n';
import { createDefaultErrorPageModel } from '../../errors';
import { sendDataLakeEventRating } from '../../utils/gtm';
import { useScreenSize } from '../../hooks/screenSizeHook';
import { ScreenSize } from '../../constants/screenSizes';

const { useRootStore, useUiStore } = generatedHooks;

const mapProps = () => {
  try {
    const rootStore = useRootStore(store => store);
    const uiStore = useUiStore(store => store);

    const { isMobile } = uiStore;

    const state = useLocalObservable(() => ({
      showErrorPage: false,
      showLoadingPage: true,
      errorCode: null,
      initializationFailed(errorCode) {
        this.showErrorPage = true;
        this.errorCode = !errorCode ? null : errorCode;
        this.showLoadingPage = false;
      },
      initializationSucceed() {
        this.showLoadingPage = false;
      },
    }));

    useEffect(() => {
      i18n.init()
        .then(() => rootStore.init())
        .then(() => {
          state.initializationSucceed();
          sendDataLakeEventRating('PageOpen');
        })
        .catch((error) => {
          const errorCode = !!error.response && !!error.response.status
            ? error.response.status
            : null;
          state.initializationFailed(errorCode);
          logger.error(error, { sentryMessage: 'initialization failed' });
        });
    }, []);

    useScreenSize((s) => {
      uiStore.setIsMobile(s < ScreenSize.DesktopNarrow);
    });

    if (state.showLoadingPage) {
      return {
        isMobile,
        showLoadingPage: state.showLoadingPage,
      };
    }

    if (state.showErrorPage) {
      return {
        isMobile,
        showErrorPage: true,
        errorPageModel: createDefaultErrorPageModel(state.errorCode),
      };
    }

    return {
      isMobile,
    };
  } catch (error) {
    logger.error(error, { sentryMessage: 'appHOC error' });
    return {
      showErrorPage: true,
      errorPageModel: createDefaultErrorPageModel(),
    };
  }
};

export default wrapInObserver(App, mapProps);
